// extracted by mini-css-extract-plugin
export default {"titleM":"index_titleM_IwuIY","titImg":"index_titImg_hbWIS","titText":"index_titText_un-uH","title":"index_title_G6qZw","date":"index_date_Eb0dV","fz30":"index_fz30_Kqmkv"};